import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  margin-right: 4px;\n  path {\n    fill: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 5px;\n  line-height: 30px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: fit-content;\n  position: relative;\n  margin-left: 50px;\n  margin-top: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { AcornsIcon } from '@acorns/icons';
import { Bodytext } from '@acorns/web-components';
import { useRemoteStrings } from '../../utils/providers/remoteStrings';
import { AI_ASSISTANT_RATING_CONTAINER, AI_ASSISTANT_RATING_STAR } from './testIDs';
var Container = styled.div(_templateObject());
var AcornContainer = styled.div(_templateObject2());
var FeedbackText = styled(Bodytext)(_templateObject3());
var AcornIcon = styled(AcornsIcon)(_templateObject4(), function (props) {
  return props.isColored ? props.theme.colors.sunrise : props.theme.colors.stoneLight;
});

var Rating = function Rating(_ref) {
  var rating = _ref.rating,
      interactionId = _ref.interactionId,
      handleRateResponse = _ref.handleRateResponse;

  var _useRemoteStrings = useRemoteStrings(),
      getRemoteString = _useRemoteStrings.getRemoteString;

  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": AI_ASSISTANT_RATING_CONTAINER,
    id: interactionId
  }, /*#__PURE__*/React.createElement(FeedbackText, null, getRemoteString({
    key: 'ai_assistant.rate_response.body'
  })), _toConsumableArray(Array(5)).map(function (_, index) {
    var givenRating = index + 1;
    return /*#__PURE__*/React.createElement(AcornContainer, {
      key: givenRating,
      "data-testid": "".concat(AI_ASSISTANT_RATING_STAR, "_").concat(givenRating),
      onClick: function onClick() {
        handleRateResponse(interactionId || '', givenRating);
      }
    }, /*#__PURE__*/React.createElement(AcornIcon, {
      icon: AcornsIcon.Icon.StarFilled,
      isColored: givenRating <= rating
    }));
  }));
};

export default Rating;